import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import useTheme from '@kufox/mui/hooks/useTheme';
import { css } from '@kufox/mui/emotion';
import { namespace } from './model';
import { separateNumber } from '../common/tools';
import { useLang } from '../hookTool';

const useStyle = ({ color }) => {
  return {
    vol: css`
      color: ${color.text};
      font-size: 12px;
      line-height: 20px;
      & .label {
        margin-right: 10px;
        color: ${color.text60};
      }
      ,
      & .unit {
        margin-left: 10px;
        color: ${color.text60};
      }
    `,
  };
};

export default function MarketsAmount() {
  const theme = useTheme();
  const { summary } = useSelector((state) => state[namespace]);
  const styles = useStyle({ color: theme.colors });
  const { t } = useLang();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch({ type: `${namespace}/pullSummary` });
  }, []);

  if (!summary || !summary.TRADING_VOLUME) {
    return null;
  }
  const baseVolAmount = summary.TRADING_VOLUME.amount;

  return (
    <div css={styles.vol}>
      <span className="label">24H{t('deal.vol')}</span>
      {separateNumber(baseVolAmount)}
      <span className="unit">USDT</span>
    </div>
  );
}
